<template>
  <div class="d-flex flex-row align-items-center">
    <CContainer>
      <div class="col-12 col-lg-8 mx-auto mt-3 mb-sm-5 mb-3">
        <h4 class="text-center mb-4">ご希望の形式を選択してください</h4>
        <div class="multisteps-form__progress">
          <button
            class="multisteps-form__progress-btn js-active"
            type="button"
            title="STEP1"
          >
            <span>
              <div class="font-weight-bolder">STEP1</div>
              オプション選択
            </span>
          </button>
          <button
            class="multisteps-form__progress-btn"
            type="button"
            title="STEP2"
          >
            <div class="font-weight-bolder">STEP2</div>
            チャットボット設定
          </button>
        </div>
      </div>
      <!-- <CRow class="justify-content-center">
        <CCol :md="2" :lg="7" :xl="6">
          <CCard class="mx-4">
            <CCardBody class="p-4">
              <h1 class="text-center mb-4"></h1>
              <CRow>
                <CCol class="text-center">
                  <CButton
                    color="info"
                    class="py-4 px-5 mx-3"
                    @click="goToStep2('web')"
                  >
                    <CIcon name="cil-browser" size="lg" class="mb-2" />
                    <div>Web</div>
                  </CButton>
                  <CButton
                    color="info"
                    class="py-4 px-5 mx-3"
                    @click="goToStep2('text')"
                  >
                    <CIcon name="cil-align-left" size="lg" class="mb-2" />
                    <div>Text</div>
                  </CButton>
                  <CButton
                    color="info"
                    class="py-4 px-5 mx-3"
                    @click="goToStep2('pdf')"
                  >
                    <CIcon name="cil-file" size="lg" class="mb-2" />
                    <div>PDF</div>
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow> -->
      <CRow class="col-12 col-lg-8 mx-auto">
        <CCol class="d-flex">
          <CButton @click="goToStep2('web')" size="lg" class="w-100 h-100 p-0">
            <CCard class="w-100 h-100">
              <CCardHeader align="center">Webサイト</CCardHeader>
              <div class="text-center">
                <img
                  src="../../public/images/browser.gif"
                  width="112"
                  height="112"
                />
              </div>
              <CCardBody align="left" style="--card-body-height: 250px">
                <div class="bg-gray-200 border-radius-lg py-4 text-xs">
                  <ul class="mb-0">
                    <li class="pe-2 pb-2">
                      Webサイトからチャットボットを作成したい場合には、<br />このオプションを選択してください。
                    </li>
                    <li class="pe-2">
                      ただし、ウェブサイト側でスクレイピング防止設定が<br />有効になっていると、正しく読み込めない場合があります。
                    </li>
                  </ul>
                </div>
              </CCardBody>
            </CCard>
          </CButton>
        </CCol>
        <CCol class="d-flex">
          <CButton @click="goToStep2('file')" size="lg" class="w-100 h-100 p-0">
            <CCard class="w-100 h-100">
              <CCardHeader align="center">ファイル</CCardHeader>
              <div class="text-center">
                <img
                  src="../../public/images/document.gif"
                  width="112"
                  height="112"
                />
              </div>

              <CCardBody align="left" style="--card-body-height: 120px">
                <div class="bg-gray-200 border-radius-lg py-4 text-xs">
                  <ul class="mb-0">
                    <li class="pe-2 pb-2">
                      ファイルからチャットボットを作成したい場合には、<br />このオプションを選択してください。
                    </li>
                    <li class="pe-2">
                      対応しているファイル形式は以下の通りです。<br />
                      なお、ファイルによっては読み込めない場合があります。
                    </li>
                  </ul>
                </div>
                <div class="p-4">
                  <div class="two-column-list">
                    <ul>
                      <li>Word (.docx)</li>
                      <li>Powerpoint (.pptx)</li>
                      <li>Excel (.xlsx)</li>
                      <li>HTML (.html)</li>
                      <li>Emails (.msg)</li>
                      <li>Images (.png, .svg)</li>
                    </ul>
                    <ul>
                      <li>Text (.txt)</li>
                      <li>CSV (.csv)</li>
                      <li>PDF (.pdf)</li>
                      <li>Markdown (.md)</li>
                      <li>JPG (.jpg, .jpeg)</li>
                    </ul>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CButton>
        </CCol>
        <!--
        <CCol class="d-flex">
          <CButton
            @click="goToStep2('audio')"
            size="lg"
            class="w-100 h-100 p-0"
          >
            <CCard class="w-100 h-100">
              <CCardHeader align="center">動画</CCardHeader>

              <div class="text-center">
                <img
                  src="../../public/images/video-channel.gif"
                  width="112"
                  height="112"
                />
              </div>

              <CCardBody align="left" style="--card-body-height: 120px">
                <div class="bg-gray-200 border-radius-lg py-4 text-xs">
                  <ul class="mb-0">
                    <li class="pe-2 pb-2">
                      動画からチャットボットを作成したい場合には、<br />このオプションを選択してください。
                    </li>
                    <li class="pe-2">
                      対応しているファイル形式は以下の通りです。<br />
                      なお、ファイルによっては読み込めない場合があります。
                    </li>
                  </ul>
                </div>

                <div class="p-4 pb-0">
                  <div class="two-column-list">
                    <ul>
                      <li>Youtube urls and playlists</li>
                      <li>Apple Audio Codec (.m4a)</li>
                      <li>MPEG Audio Layer 3 (.mp3)</li>
                      <li>WebM Media (.webm)</li>
                      <li>MPEG-4 (.mp4)</li>
                      <li>MPGA Audio (.mpga)</li>
                      <li>WAV Format (.wav)</li>
                      <li>MPEG (.mpeg)</li>
                      <li>MOV QuickTime (.mov)</li>
                      <li>FLAC (.flac)</li>
                    </ul>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CButton>
        </CCol>
        -->
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {
  CCard,
  CCardHeader,
  CCardBody,
  CContainer,
  CRow,
  CCol,
  CButton,
} from '@coreui/vue'
// import { CIcon } from '@coreui/icons-vue'
//import HTTPService from '@/services/HTTPService'

export default {
  name: 'ChatbotWizardPage1',
  components: {
    CCardHeader,
    CCard,
    CCardBody,
    CContainer,
    CRow,
    CCol,
    CButton,
    // CIcon,
  },
  props: {
    bot_id: {
      type: String,
      required: false,
    },
    chatbot_name: {
      type: String,
      required: false,
    },
  },
  mounted() {
    //HTTPService.getuser()
    //  .then((response) => {
    //    ////console.log(response.data.user)
    //    this.user = response.data.user
    //  })
    //  .catch((error) => {
    //    console.error(error)
    //    this.$emit('change-active-component', {
    //      component: 'Login',
    //    })
    //  })
  },
  methods: {
    goToStep2(stepType) {
      this.$emit('change-active-component', {
        component: 'ChatbotStep2',
        params: {
          botType: stepType,
          bot_id: this.bot_id,
          chatbot_name: this.chatbot_name,
        },
      })
    },
  },
}
</script>

<style>
h1 {
  font-size: 2.5rem;
  font-weight: 500;
}

button {
  font-size: 1.3rem;
}

@media (max-width: 576px) {
  h1 {
    font-size: 2rem;
  }

  button {
    font-size: 1rem;
  }
}

.selection .h-100:first-child .card-body {
  height: 270px;
}

.selection .h-100:not(:first-child) .card-body {
  padding-bottom: calc(20px + (270px - var(--card-body-height)));
}

.two-column-list {
  display: flex;
  justify-content: center;
  margin-left: 10px;
}

.two-column-list ul {
  list-style-type: disc; /* Add this line to display bullet points */
  padding-left: 0;
  text-align: left; /* Center the text within each list item */
}

.two-column-list ul:first-child {
  margin-right: 100px; /* Add right margin to create padding between columns */
}
</style>
